import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    Promise.all([import('choices.js'), import('choices.js/public/assets/styles/choices.css')]).then(
      ([{ default: Choices }]) => {
        const select = this.element.querySelector('select');
        this.choices = new Choices(select, {
          removeItemButton: true,
          classNames: {
            containerOuter: ['choices', 'o-form-field-select', 'o-form-field-select--choices'],
          },
        });
      },
    );
  }

  disconnect() {
    this.choices?.destroy();
  }
}
